module.exports = __webpack_public_path__ + "static/media/badge-exl-chart.b1d00214.jpg";